import { jsx } from "react/jsx-runtime";
export default function SvgIcon(props) {
  return /* @__PURE__ */ jsx("svg", { ...props, width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("circle", { cx: "4", cy: "4", r: "4", fill: "#EA1E51" }) });
}
